var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "19px",
    height: "25px",
    viewBox: "0 0 28 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg-bag"
  }, "Shopping Cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg-bag"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav---Black",
    transform: "translate(-1272.000000, -9.000000)",
    fill: "#111111",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1148.353846, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HNY-web-Shop",
    transform: "translate(124.500254, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1292308,7.78640031 C21.1292308,3.48609016 17.6391182,0 13.3338462,0 C9.02857411,0 5.53846154,3.48609016 5.53846154,7.78640031 L0,7.78640031 L0,35.9087207 L26.6510769,35.9087207 L26.6510769,7.78640031 L21.1292308,7.78640031 Z M13.3338462,1.79239339 C16.6678385,1.79748196 19.3895674,4.45716094 19.4676923,7.78640031 L7.2,7.78640031 C7.27812491,4.45716094 9.99985378,1.79748196 13.3338462,1.79239339 Z M24.9978462,34.2490972 L1.66984615,34.2490972 L1.66984615,9.44602382 L5.54676923,9.44602382 L5.54676923,12.9450634 L7.20830769,12.9450634 L7.20830769,9.44602382 L19.4704615,9.44602382 L19.4704615,12.9450634 L21.132,12.9450634 L21.132,9.44602382 L25.0089231,9.44602382 L24.9978462,34.2490972 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket2);
export default __webpack_public_path__ + "static/media/basket-2.55898a1c66598483f9d9c755d3d91992.svg";
export { ForwardRef as ReactComponent };